import ID from './ID';
import PH from './PH';

export default {
  ID,
  PH
};
